import image1 from '../../assets/images/2.jpg';

import './product-card.styles.scss';

const ProductCard = ({ image, title, model, material, price, sizes }) => {
  return (
    <div className='main-product-container'>
      <div className='product-container'>
        <div className='imgBx'>
          <img src={image} alt='' />
        </div>
        <div className='details'>
          <div className='content'>
            <h2>{title}</h2>
            <div className='vine-line' />
            <br />
            <h4>Модель: {model}</h4>
            <h4>Сировина: {material}</h4>
            <h4>
              Розміри:
              <div className='dimensions'>
                Довжина {sizes[0]} см, <br /> Ширина {sizes[1]} см, <br /> Висота {sizes[2]} см
              </div>
            </h4>
            <br />
            <h3>Ціна: {price} ГРН</h3>
            <br />
            <a href='#contact-us'>
              <button>Замовити</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
